/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherTypeEnum {
  SupplierInvoice = 'supplier_invoice',
  SupplierCreditNote = 'supplier_credit_note',
  Expense = 'expense'
}
